/*
  YUYOU — vloeiend scrollen met Lenis (assets/lenis.min.js, v1.3.26, MIT,
  darkroom.engineering).

  Waarom: de animaties op de site hangen aan de scrollpositie. Met een
  muiswiel springt die in stappen van zo'n 100px, en de animaties springen
  mee. Lenis laat de scrollpositie zelf vloeiend naar het doel toe bewegen,
  zodat elke scroll-animatie op de site in één keer vloeiend wordt.

  - Alleen muis en trackpad. Aanraakschermen scrollen native (syncTouch staat
    standaard uit): daar is het al vloeiend en verwachten mensen niets anders.
  - Wie bewegingsarm werkt, krijgt gewoon het normale scrollen.
  - Ankerlinks (#brand, #brands …) scrollen vloeiend naar hun blok.
  - Menu's en lades die zelf scrollen, blijven zelf scrollen.
  - Een open lade (menu, winkelmand) zet Lenis stil. Dawn zet dan een klasse
    overflow-hidden… op de body; zonder dit scrolde de pagina achter de lade.
*/
(function () {
  var lenis = null;
  var bewegingsarm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (typeof window.Lenis === 'function' && !bewegingsarm) {
    lenis = new window.Lenis({
      autoRaf: true,
      lerp: 0.09,
      anchors: true,
      allowNestedScroll: true,
      stopInertiaOnNavigate: true
    });

    var volgLade = function () {
      var vast = Array.prototype.some.call(document.body.classList, function (klasse) {
        return klasse.indexOf('overflow-hidden') === 0;
      });
      if (vast) lenis.stop();
      else lenis.start();
    };

    new MutationObserver(volgLade).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    volgLade();

    window.yuyouLenis = lenis;
  }

  /*
    Een menu-item dat naar een blok op deze pagina wijst, zoals /#amsterdam op
    de homepage. Zolang het menu open is staat Lenis stil, en Dawn sluit het
    menu niet bij zo'n klik: de browser sprong in één keer naar het blok, met
    het menu er nog overheen. Nu gaat eerst het menu dicht en glijdt de pagina
    daarna naar het blok. Wie bewegingsarm werkt springt direct, maar ook dan
    gaat het menu eerst dicht.

    Alleen voor links in het menu. Andere ankerlinks, zoals de knoppen in de
    hero, handelt Lenis zelf af.
  */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href*="#"]') : null;
    if (!link) return;

    var lade = link.closest('header-drawer');
    if (!lade) return;

    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;

    var doel = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!doel) return;

    event.preventDefault();
    // Lenis luistert zelf op window naar ankerklikken en staat nu nog stil.
    event.stopPropagation();

    // HeaderDrawer in global.js sluit alleen als je meegeeft waar de focus
    // daarna heen moet; zonder tweede argument doet hij niets.
    var menuknop = lade.querySelector('summary');
    if (typeof lade.closeMenuDrawer === 'function' && menuknop) lade.closeMenuDrawer(event, menuknop);
    // closeMenuDrawer zet aria-expanded alleen bij een toetsaanslag terug; bij
    // een klik doet de klikhandler op de summary dat, en die slaan we hier
    // over. Bleef hij op true staan, dan tekende base.css onder het eiland een
    // witte laag van 50% tot onderaan het scherm.
    if (menuknop) menuknop.setAttribute('aria-expanded', 'false');
    if (window.history && window.history.pushState) window.history.pushState(null, '', url.hash);

    // De focus naar het blok, zoals de browser bij een gewone ankerlink doet:
    // wie met het toetsenbord verder tabt, gaat vanaf daar verder.
    // focus-none (base.css): geen focusrand om een heel blok heen.
    if (!doel.hasAttribute('tabindex')) {
      doel.setAttribute('tabindex', '-1');
      doel.classList.add('focus-none');
    }
    doel.focus({ preventScroll: true });

    if (lenis) {
      lenis.start();
      lenis.scrollTo(doel, { force: true });
    } else {
      doel.scrollIntoView();
    }
  });
})();
